import mutations from './mutations';
import actions from './actions';
import getters from './getters';
const userStore = {
    state: {
        isTabSelect: 0,
        isListTab: []
    },
    mutations,
    actions,
    getters
};

export default userStore;
